import React from "react";
import { useGetListOptionQuery } from "../api/GetListOption";
import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";

export default function useGetListOptionHook() {
    const { showNotification } = useUtilitiesContext();

    const {
        data: listOptions = [],
        isError: isListOptionsError,
        error: listOptionError,
        isFetching: isListOptionFetching,
        refetch: refetchListOption
    } = useGetListOptionQuery([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);

    React.useEffect(() => {
        if (isListOptionsError) {
            showNotification({
                type: "error",
                title: "Error",
                message: listOptionError.message,
            });
        }
    }, [isListOptionsError, listOptionError, showNotification]);

    return {
        listOptions,
        isListOptionFetching,
        refetchListOption
    }
}